import { Injectable } from "@angular/core";
// import {Http, Response, Headers} from '@angular/http';
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";

import { UsblickCommonEnum } from "../usblick-common-enum";
import { UserService } from "./user.service";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "environments/environment";
import { setting } from '../../../../../setting';
import { catchError, filter, map, take, takeUntil } from "rxjs/operators";
import { BehaviorSubject, of, Subject } from "rxjs";
import { ConfirmationModalComponent } from "app/shared/modals/confirmation-modal/confirmation-modal.component";
import { SellerSelectModalComponent } from "app/shared/modals/seller-select-modal/seller-select-modal.component";
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from "ngx-toastr";
import { ItineraryService } from "app/shared/itinerary.service";
import { FidelityService } from "app/fidelity/fidelity.service";
import { AgentsService } from "app/agents/agents.service";
import { select, Store } from "@ngrx/store";
import { AppState } from "app/core/profiles/storeProfile";
import { selectPermissions } from "app/core/profiles/profiles.selectors";

@Injectable()
export class AuthService {
  public apiBookingUrl: string;
  //user
  _name: string = '';
  _email: string = '';
  _agentID: number = 0;
  //agent
  _agencyName: string = '';
  _agencyID: string = '';
  _imagen_logotype: string = '';
  authInfoLoaded$ = new BehaviorSubject<boolean>(false);
  profileSeller$ = new BehaviorSubject<boolean>(false);
  changeAgencySeller$ = new BehaviorSubject<boolean>(false);
  url: string;
  private authUrl = setting.authApiUrl;
  public appUrl = setting.appUrl

  private isModalOpen: boolean = false;
  private permissions$: Observable<string[]>;
  private permissionsMap: { [key: string]: boolean } = {};
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private permissionsLoaded = false;
private permissionsArray: any[] = [];
private isProcessing = false;

  constructor(
                private _http: HttpClient,
                private bsModalService: BsModalService,
                public userService: UserService,
                private itineraryService: ItineraryService,
                private fidelityService: FidelityService,
                private agentService: AgentsService,
                 private store: Store<AppState>,
                public toasrt: ToastrService) {
    this.url = window.location.href;
    this.apiBookingUrl = setting.apiBookingUrl;

    // tslint:disable-next-line:indent
    if (setting.ActivatedGuard) {

      // this._getAgent();
      // console.log('active _getAgent()')


    } else {
      // tslint:disable-next-line:indent
      this.userService.userActive = {
        address: "None",
        agency_commission: "20",
        agency_id: "1",
        agent_id: "2",
        created_by: "1",
        email: "agency@demo.com",
        email_user: "agente@usblick.com",
        enable: "1",
        first_name: "Agente",
        imagen_logotype: "",
        last_name: "Agente",
        name_agency: "Agencia",
        name_business: "Business",
        name_role: "Agent",
        pay_mode: "1",
        phone: "04245555555",
        status: "1",
        tax_id: "J-00000000",
        user_id: "2",
        profitability: "0",
      };

      this.userService._name = "Agente Agente";
      this.userService._email = "agente@usblick.com";
      this.userService._agentID = 2;
      this.userService._agencyName = "Agencia";
      this.userService._agencyID = 1;
      this.userService.activeUserSubject.next(userService.userActive);
      this.userService._imagen_logotype = "";
      const prueba = this.userService.userActive;

      localStorage.setItem("selectedAgency", JSON.stringify(this.userService.userActive));
    }

  }

  validate(data: any, type: string) {
    const json = JSON.stringify(data);
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        "client-id": "environment.client_id",
        "client-secret": "environment.client_secret",
        Authorization: "Bearer " + this.getCookie("auth_token"),
      }),
    };
    return this._http.post(this.apiBookingUrl + UsblickCommonEnum.validService + json, httpOptions);
  }

  logout(data: any) {
    const json = JSON.stringify(data);
    let headers = new HttpHeaders();

    headers.set('Content-Type','application/json');
    headers.set('Authorization','Bearer ' + this.getCookie("auth_token"));

    return this._http.post(this.apiBookingUrl + UsblickCommonEnum.logoutService , json, {headers: headers});
  }

  getCookie(name: string) {
    //console.log ("document.cookie", document.cookie);
    var nameEQ = encodeURIComponent(name) + UsblickCommonEnum.equalChar;
    var ca = document.cookie.split(UsblickCommonEnum.dotCommaChar);
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === UsblickCommonEnum.spaceChar) c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  /**
   * Cookie Register
   * @param cname
   * @param cvalue
   * @param exdays exdays = -1,  to delete  cookie.|  exdays = null, to inifinite.
   */
async loadPermissions(): Promise<any[]> {
  // Si ya cargó, retornar lo que tiene
  if (this.permissionsLoaded) {
    return this.permissionsArray || [];
  }

  this.store.dispatch({ type: '[Auth] Load Permissions' });

  // 👇 ESPERAR HASTA QUE TENGA DATOS (no solo 1 vez)
  const permissions = await this.store.select(selectPermissions).pipe(
    filter(perms => perms && perms.length > 0), // 👈 ESPERAR A QUE TENGA DATOS
    take(1)
  ).toPromise();

  const permissionsArray = Array.isArray(permissions) ? permissions : [];
  this.permissionsMap = this.createPermissionsMap(permissionsArray);

  this.permissionsLoaded = true;
  this.permissionsArray = permissionsArray;

  return permissionsArray;
}

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      map[permission.name] = permission;
    });
    return map;
  }


async _getAgent(permissions: any) {
  if (this.isProcessing) {
    return;
  }

  this.isProcessing = true;

  let url = setting.apiBookingUrl;
  let headers = new HttpHeaders();

  headers = headers.set("Content-Type", "application/json");
  headers = headers.set("Authorization", `Bearer ${this.getCookie('auth_token')}`);

  try {
    const Response: any = await this._http.get(url + "user/current?from=booking", {headers: headers})
      .toPromise();

    this.userService._agent = Response["det"];
    this.userService._profile = Response["det"]["profile"];
    this.userService._name = Response["det"]["first_name"] + " " + Response["det"]["last_name"];
    this.userService._email = Response["det"]["email"];
    this.userService._agentID = Response["det"]["id"];
    this.userService._providerId = Response["det"]["provider_id"] ? [Response["det"]["provider_id"]] : null

    // Cargar permisos y ESPERAR que tengan datos
    await this.loadPermissions();

    // 👇 VERIFICACIÓN EXPLÍCITA
    const tienePermiso = this.permissionsMap['booking.ingresosinagencia'] !== undefined;

    if (tienePermiso) {

      const storedSellerRaw = sessionStorage.getItem('sellerProfile');
      const agentAgencyInfoRaw = localStorage.getItem('selectedAgency');
      const agentAgencyInfo = agentAgencyInfoRaw ? JSON.parse(agentAgencyInfoRaw) : null;
      const sellerStore = storedSellerRaw ? JSON.parse(storedSellerRaw) : null;

      if (sellerStore && agentAgencyInfo &&
          sellerStore.agencyId === agentAgencyInfo.agency_id &&
          sellerStore.agentId === agentAgencyInfo.agent_id) {
        this.agencyShow(Number(sellerStore.agencyId));
      } else {
        this.openAgencyModal();
      }
    } else {

      // EJECUTAR LAS FUNCIONES
      this.agencyData(Response["det"]["agency"], Response["det"]["currency"]);
      this.setBalance(Response["det"]["balanceAgency"]);
      this.setPaymentCondition(Response["det"]["agencyPaymentCondition"]);

      if (Response["det"]["itineraryActive"]?.data?.length > 0) {
        this.userService.itineraryUpdateProductsTotalPrices(Response["det"]["itineraryActive"].data[0].id);
        this.itineraryService.itinerary = Response["det"]["itineraryActive"].data[0];
        const itineraryActive = [Response["det"]["itineraryActive"].data[0], Response["det"]["itineraryActive"].data[0].clients];
        this.itineraryService.sendMessageActiveItinerary(itineraryActive);
      }
    }

  } catch (Error) {
    console.log("Error: ", Error);
    window.location.href = this.appUrl;
  } finally {
    this.isProcessing = false;
  }
}

//   _getAgent(permissions: any) {

//     let url = setting.apiBookingUrl;
//     let headers = new HttpHeaders();

//     headers = headers.set("Content-Type", "application/json");
//     headers = headers.set("Authorization", `Bearer ${this.getCookie('auth_token')}`);

//     this._http.get(url + "user/current?from=booking", {headers: headers})
//     //  this._http.get(url + "user/current", {headers: headers})
//       .catch(this.handleError)
//       .pipe(
//         take(1)
//       )
//       .subscribe({
//         next: (Response: any) => {
//           this.userService._agent = Response["det"];
//           this.userService._profile = Response["det"]["profile"];
//           this.userService._name = Response["det"]["first_name"] + " " + Response["det"]["last_name"];
//           this.userService._email = Response["det"]["email"];
//           this.userService._agentID = Response["det"]["id"];

// console.log(permissions)
//           this.getPermissions();
// console.log(this.permissionsMap)
//           if (this.permissionsMap['booking.ingresosinagencia']) {
//         const storedSellerRaw = sessionStorage.getItem('sellerProfile');
//         const agentAgencyInfoRaw = localStorage.getItem('selectedAgency');
//         const agentAgencyInfo = agentAgencyInfoRaw ? JSON.parse(agentAgencyInfoRaw) : null;
//         const sellerStore = storedSellerRaw ? JSON.parse(storedSellerRaw) : null;

//         if (
//             sellerStore && agentAgencyInfo &&
//             sellerStore.agencyId === agentAgencyInfo.agency_id &&
//             sellerStore.agentId === agentAgencyInfo.agent_id
//           ){
//             // const parsed = JSON.parse(storedSeller);
//             // Podés validar si el timestamp es reciente o simplemente confiar en que existe
//             this.agencyShow(Number(sellerStore.agencyId));

//           } else {
//             this.openAgencyModal();
//         }
//       }
//        else {
//             this.agencyData(Response["det"]["agency"], Response["det"]["currency"]);
//             this.setBalance(Response["det"]["balanceAgency"]);
//             this.setPaymentCondition(Response["det"]["agencyPaymentCondition"]);
//             if(Response["det"]["itineraryActive"] && Response["det"]["itineraryActive"].data && Response["det"]["itineraryActive"].data.length > 0) {
//               this.userService.itineraryUpdateProductsTotalPrices( Response["det"]["itineraryActive"].data[0].id);
//               this.itineraryService.itinerary = Response["det"]["itineraryActive"].data[0];
//               const itineraryActive = [Response["det"]["itineraryActive"].data[0], Response["det"]["itineraryActive"].data[0].clients];
//               this.itineraryService.sendMessageActiveItinerary(itineraryActive);
//             }
//           }
//         },
//         error: (Error: HttpErrorResponse) => {

//           console.log("Error: ", Error);
//           window.location.href = this.appUrl;
//         }
//       });
//   }

  openAgencyModal(): void {
  // Verificar si ya está abierto
  if (this.isModalOpen) {
    console.log('El modal ya está abierto');
    return;
  }

  // Marcar como abierto
  this.isModalOpen = true;

  const initialState = {
    showCancelButton: true,
    confirmText: 'Si',
    cancelText: 'No'
  };

  const modalRef = this.bsModalService.show(SellerSelectModalComponent, {
    initialState,
    class: 'modal-lg',
    backdrop: 'static',
    keyboard: false
  });

  modalRef.content.confirmResult.subscribe((result: any) => {
    // Marcar como cerrado
    this.isModalOpen = false;

    if (result && result.success) {
        if(this.userService._agencyID && this.userService.itineraryActive && this.userService.itineraryActive.length > 0)  {

        const confirmModalRef = this.bsModalService.show(ConfirmationModalComponent, {
          initialState: {
            title: 'Cambio de agencia',
            message: 'Esta seguro que quiere cambiar de agencia',
            showCancelButton: true,
            confirmText: 'Si',
            cancelText: 'No'
          },
          class: 'modal-md',
          backdrop: 'static',
          keyboard: false
        });

        confirmModalRef.content.confirmResult.subscribe((resultOthersAgencyActive: any) => {
          if(resultOthersAgencyActive) {
            this.itineraryService.updateActiveItinerary(this.userService.itineraryActive[0], false);
            sessionStorage.setItem('sellerProfile', JSON.stringify({
                  agencyId: Number(result.agencyId),
                  agentId: this.userService._agentID,
                  timestamp: new Date().toISOString()
                }));

                this.agencyShow(Number(result.agencyId));
          } else {
            return;
          }
        })

      } else {
          sessionStorage.setItem('sellerProfile', JSON.stringify({
            agencyId: Number(result.agencyId),
            agentId: this.userService._agentID,
            timestamp: new Date().toISOString()
          }));

          this.agencyShow(Number(result.agencyId));
      }

    } else {

      if(!this.userService._agencyID ||
          this.userService._agencyID === null
      ) {
        this.letsRedirect();
      }
    }
  });
}

  agencyShow(id: number): void {

    let url = setting.apiBookingUrl;
    let headers = new HttpHeaders();
    headers = headers.set("Accept", "application/json");
    headers = headers.set("Content-Type", "application/json");
    headers = headers.set("client-id", setting.client_id);
    headers = headers.set("client-secret", setting.client_secret);
    headers = headers.set("Authorization", "Bearer " + this.getCookie("auth_token"));
    this._http.get(url + "agencies/" + id, { headers: headers }).subscribe({
      next: (res: any) => {
        if(res && res?.data && res?.data?.agency) {
          const selectedAgency = {
            address: res.data.agency?.address,
            agency_comission: res.data.agency?.agency_comission,
            agency_id: res.data.agency?.id,
            country: res.data.agency?.country,
            agent_id: this.userService._agentID,
            channel_id: res.data.agency?.channel,
            created_by: res.data.agency?.created_by,
            email: res.data.agency?.email,
            imagen_logotype: res.data.agency?.imagen_logotype,
            language: res.data.agency?.language,
            license: res.data.agency?.license,
            location_agency_id: res.data.agency?.location_agency_id,
            name_agency: res.data.agency?.name,
            name_business: res.data.agency?.name_business,
            pay_mode: res.data.agency?.pay_mode,
            phone: res.data.agency?.phone,
            profitability: res.data.agency?.profitability,
            status: res.data.agency?.status,
            tax_id: res.data.agency?.tax_id,
            user_id: res.data.agency?.user_id,
            currency: res.data.agency?.currency,
            executive: res.data.agency?.executive,
            contact_commercial: {
              first_name: res.data.agency.first_name_com,
              last_name: res.data.agency.last_name_com,
              email: res.data.agency.email_com,
              phone_code: res.data.agency.phone_cc_code,
              phone: res.data.agency.phone_com,
              day_from: res.data.agency.day_from_com,
              day_to: res.data.agency.day_to_com,
              hour_from: res.data.agency.hour_from_com,
              hour_to: res.data.agency.hour_to_com
            }
          }
          this.userService.userActive = selectedAgency;
          this.userService.userActive.name = res.data?.agency?.name;
          this.userService.activeUserSubject.next(res.data.agency);
          this.userService._imagen_logotype = res.data.agency?.imagen_logotype;
          this.userService._channel_id = res.data.agency?.channel_id;
          this.userService._licenseId = res.data.agency?.license;
          this.userService._marketId = res.data.agency?.location_agency_id;
          this.userService._agencyID = res.data.agency?.id;
          this.userService._agencyName = res.data?.agency?.name;
          // this.userService.currency = res.data.agency?.currency;
           this.getCurrencyAgency(res.data.agency?.currency);
          localStorage.setItem("selectedAgency", JSON.stringify(this.userService.userActive));
          if(this.userService.userActive) {
            this.profileSeller$.next(true);
            this.changeAgencySeller$.next(true);
            // this.authInfoLoaded$.next(true);
          }
        }
          // localStorage.setItem("selectedAgency", JSON.stringify(this.userService.userActive));
      },
      error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })

  }


  agencyData(agency: any, currencyAgency: any): void {

    if(!agency || !currencyAgency) {
      this.toasrt.error('Falta información de la agencia o la moneda configurada de la agencia');
      this.letsRedirect();
    }

    agency = agency[0];
    const responseAgencyAdapter = {data: [agency]}
    this.userService.userActive = agency;
    this.userService.activeUserSubject.next(responseAgencyAdapter);
    this.userService._imagen_logotype = agency.imagen_logotype;
    this.userService._channel_id = agency.channel_id;
    this.userService._licenseId = agency.license;
    this.userService._marketId = agency.location_agency_id;
    this.userService._agencyID = agency.agency_id;
    this.userService._agencyName = agency.name_agency;
    this.userService.currency = currencyAgency;
    // this.getCurrencyAgency(currencyAgency?.code);
    localStorage.setItem("selectedAgency", JSON.stringify(this.userService.userActive));
          if(this.userService.userActive) {
            this.authInfoLoaded$.next(true);
          }


  }

  setBalance(balanceAgency: any): void {

    this.userService.creditsDeposits = parseFloat(balanceAgency?.balanceCreditsDeposits) ? parseFloat(balanceAgency?.balanceCreditsDeposits) : 0;
    this.fidelityService.creditDepositActives = this.userService.creditsDeposits;
    this.userService.credits = parseFloat(balanceAgency?.balanceCredits) ?  parseFloat(balanceAgency?.balanceCredits) : 0;
    this.userService.creditLimits = this.userService.credits + this.userService.creditsDeposits;
    this.userService.balanceBlickoins = parseFloat(balanceAgency.agent?.availableBlickoins) ? parseFloat(balanceAgency.agent?.availableBlickoins) : 0;
    this.userService.creditBlickoins = parseFloat(balanceAgency.agent?.availableCreditBlickoins) ? parseFloat(balanceAgency.agent?.availableCreditBlickoins) : 0;

  }

  setPaymentCondition(payConditionAgency: any): void {
    this.agentService.paymentConditions = payConditionAgency;
    this.itineraryService.paymentConditionName = payConditionAgency.name;
    this.itineraryService.paymentConditionIcono = payConditionAgency.icono;
    this.itineraryService.paymentConditions = payConditionAgency;
  }


  // tslint:disable-next-line:member-ordering
  getAgencyName(agentId: any) {
    let url = setting.apiBookingUrl;

    let headers = new HttpHeaders();
    headers = headers.set("Accept", "application/json");
    headers = headers.set("Content-Type", "application/json");
    headers = headers.set("client-id", setting.client_id);
    headers = headers.set("client-secret", setting.client_secret);
    headers = headers.set("Authorization", "Bearer " + this.getCookie("auth_token"));
this._http
      .get(url + "agents/" + agentId, { headers: headers })
      .map((response: any) => response)
      .catch(this.handleError)
      .subscribe({
        next: (response: any) => {
          // this.userService.userActive = response.data[0];
          // this.userService.activeUserSubject.next(response);
          // this.userService._imagen_logotype = response.data[0].imagen_logotype;
          // this.userService._channel_id = response.data[0].channel_id;
          // this.userService._licenseId = response.data[0].license;
          // this.userService._marketId = response.data[0].location_agency_id;
          // this.userService._agencyID = response.data[0].agency_id;
          // this.userService._agencyName = response.data[0].name_agency;
          this.getCurrencyAgency(response.data[0].currency);
          localStorage.setItem("selectedAgency", JSON.stringify(this.userService.userActive));
          if(this.userService.userActive) {
            this.authInfoLoaded$.next(true);
          }

        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        }
      });
  }

  getCurrencyAgency(currencyId: string): void {
    this._http.get(`${this.authUrl}clients-with-currencies`).subscribe({
      next: (res: any) => {
        if(res.status) {
          const currencyClient = res?.data.find(c => c.id === this.userService.clientIdFusion);

          if(currencyClient) {
            this.userService.currency = currencyClient?.currencies?.find(c => c.code === currencyId);

          } else {
            this.toasrt.warning('Moneda no configurada en la agencia. Solicite configuración')
            window.location.href = this.appUrl;
          }

        }
      },
      error: (error: HttpErrorResponse) => {

      },
    })
  }

      setCookie(cname, cvalue, exdays, domain, secure = true, httpOnly = true) {
      // Establecer la fecha de expiración de la cookie
      if (exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));  // Calcular la fecha de expiración
          var expires = "expires=" + d.toUTCString();  // Fecha en formato UTC
      } else {
          var expires = "";  // Cookie de sesión
      }

      // Configurar los atributos de la cookie
      var cookie = cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/"; // Configuración común

      if (secure && window.location.protocol === 'https:') {
        cookie += ";Secure";
      }

      // Escribir la cookie en el navegador
      document.cookie = cookie;
    }


getCurrenciesExchanges(): Promise<any> {
  return new Promise((resolve, reject) => {
    this._http.get(`${this.authUrl}currencies`).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.userService.currenciesExchange = res.data;
          resolve(res.data); // Resuelve la promesa con los datos
        } else {
          reject(new Error('La respuesta no tiene status true'));
        }
      },
      error: (error: HttpErrorResponse) => {
        reject(error); // Rechaza la promesa en caso de error
      }
    });
  });
}

getApplicationClient(clientSystemId: number): Observable<any> {

  return  this._http.get(`${this.authUrl}available-categories?client_id=${clientSystemId}&application_id=2`);

  }




  getProfiles(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.getCookie('auth_token'));
    return this._http.get<any>(`${this.apiBookingUrl}profile/list`, { headers: headers}).
    pipe(map(res => res.data));
}
  // Handling errors in response
  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body: any = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  letsRedirect(){
    window.location.href = setting.appUrl + UsblickCommonEnum.redirectQuery + encodeURIComponent(this.url);
  }

  getExecutive(id: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + this.getCookie('auth_token'));

    const url = `${this.apiBookingUrl}executives`;
    return this._http.get<any>(url, { headers: headers}).pipe(
      map(response => {
        // Verifica si la respuesta tiene la estructura esperada
        if (response && response.users && Array.isArray(response.users)) {
          return response.users.find(user => user.id === id);
        }
        return null; // O undefined si prefieres
      }),
      catchError(error => {
        console.error('Error fetching executives:', error);
        return of(null); // Manejo de errores
      })
    );
  }
}
function firstValueFrom(arg0: Observable<string[]>) {
  throw new Error("Function not implemented.");
}

